module.exports = __webpack_public_path__ + "img/Enmascarar-grupo-1-new.6738f405.png";